export default __webpack_public_path__ + "static/media/duckLeft.fd5c329e.png";